import * as React from "react"
import { MetadataModel } from "./models"
import { Helmet } from "react-helmet"
const Metadata: React.FC<MetadataModel & { imageUrl?: string }> = ({ title, description, type, imageUrl }) => {
  const url = window.location.href
  return (
    <Helmet>
      <meta property="og:title" content={title} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      {description && <meta property="og:description" content={description} />}
      <title>{title} | Satcube.com</title>
    </Helmet>
  )
}
export default Metadata
